import { SagaIterator } from 'redux-saga'
import { takeLatest, all } from 'redux-saga/effects'

// tslint:disable-next-line:no-empty
export function* rootSagas(): SagaIterator { }



// WEBPACK FOOTER //
// ./src/sagas/index.ts